import axios from "axios";
import { getToken } from "./AuthService";

// const BASE_REST_API_URL = 'http://localhost:8080/api/strategiessheet';
const BASE_REST_API_URL = 'http://159.89.182.193:8080/api/strategiessheet';

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    config.headers['Autorization'] = getToken();
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

export const getAllStrategiesSheet = () => axios.get(BASE_REST_API_URL)